import {i18n} from '../i18n'

const translationKeys = {
    INVALID_PROFILE_LINK: 'errors.invalidProfileLink',
    EMAIL_ALREADY_IN_USE: 'errors.emailAlreadyInUse',
    RATE_LIMITED: 'errors.rateLimited',
    UNKNOWN_ERROR: 'errors.unknown',
}

export const getApiErrorMessage = (error, fallback) => {
    const data = error?.response?.data
    const translationKey = translationKeys[data?.error]
    return translationKey
        ? i18n.t(translationKey)
        : fallback
}
